module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "categoriesPickerWrapper"
  }, _vm._l((_vm.categories), function(category) {
    return (category.id) ? _c('li', {
      key: category.id,
      class: _vm.activate === _vm.hauteur || _vm.hauteur === 1 ? 'active' : ''
    }, [_c('span', {
      staticClass: "block full pointer"
    }, [_c('div', {
      key: category.id,
      class: ['sectionType', 'pointer', category.subCategories.length > 0 ? 'haveChildren' : ''],
      on: {
        "click": function($event) {
          _vm.$emit('updateQuery', {
            name: 'Catalog',
            query: _vm.getLinkParams({
              category: category.id
            })
          });
          _vm.changeg(category.id);
        }
      }
    }, [_vm._v("\n                " + _vm._s(category.terms.name[_vm.$t("trad")]) + "\n            ")])]), _vm._v(" "), (category.subCategories.length) ? _c('category-picker', {
      attrs: {
        "categories": category.subCategories,
        "isActive": category.id === _vm.selectCategoryId ? _vm.hauteur + 1 : 0,
        "getLinkParams": _vm.getLinkParams,
        "getRouteParams": _vm.getRouteParams,
        "hauteur": _vm.hauteur + 1
      },
      on: {
        "updateQuery": function($event) {
          _vm.$emit('updateQuery', $event);
        }
      }
    }) : _vm._e()], 1) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ba6198","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/category-picker.vue
// module id = 3145
// module chunks = 0